import TileItemInfo from "../../molecules/TileItemInfo/TileItemInfo";
import TileItemImgInfo from "../../molecules/TileItemImgInfo/TileItemImgInfo";
import { languages } from "../../../dummyData/dummyData";
import TileItem from "../TileItem/TileItem";
import { generatePath, useHistory } from "react-router-dom";
import { Routes } from "../../../routes";
import { regulatoryIntelligenceRepository } from "../../../repository/regulatoryIntelligence.repository";
import { ACTIONS, PopupsContext } from "../../../contexts/PopupsContext";
import { popupFields } from "../../templates/RegulatoryIntelligenceTemplate/RegulatoryIntelligenceTemplate";
import React, { useContext, useEffect, useState } from "react";
import { dateFormat } from "../../../utils/formatters";
import Text from "../../atoms/Text/Text";
import useFetch from "../../../hooks/useFetch";
import { getUserDisplayText } from "../Table/LicensesTable/LicensesTable";
import { organizationRepository } from "../../../repository/organization.repository";

const selectUsersPopupFilterDefinitions = [
  {
    keyPath: ["user.profile.name", "user.profile.surname", "user.email"],
  },
  {
    keyPath: "user.profile.user_career_path.name",
    header: languages.EN.labels.careerPath,
    typeOfFilter: "checkbox",
  },
];

const PopupRenderItem = ({ item }) => {
  const user = item.user;
  const profile = user.profile;

  return (
    <Text s12 dark-4>
      {profile.name ? `${profile.name} ${profile.surname} (${user.email})` : user.email}
    </Text>
  );
}
const RegulatoryIntelligenceItemTile = ({ data }) => {
  const { id, title, profile_image_small, learningArea, category, languageName, likes, created, visibility, visibilityImg, user_liked, url, canEdit } = data;
  const { callPopup, setIsDataActive } = useContext(PopupsContext);
  const [userLiked, setUserLiked] = useState(user_liked);

  let history = useHistory();

  const fetchOrganizationMembersForShare = useFetch();
  useEffect(() => {
    if (fetchOrganizationMembersForShare.isReady) {
      setIsDataActive(true);
      callPopup({
        type: ACTIONS.SELECT,
        payload: {
          header: languages.EN.labels.shareWith,
          items: fetchOrganizationMembersForShare.data.map(item => ({
            ...item,
            id: item.user.username,
            label: getUserDisplayText(item.user),
          })),
          RenderItem: PopupRenderItem,
          filters: selectUsersPopupFilterDefinitions,
          singleSelect: false,
          postAction: (formData) => regulatoryIntelligenceRepository.shareArticle({ article: id, users: formData }),
        },
      });
    }
  }, [fetchOrganizationMembersForShare.isReady]);

  return (
    <TileItem title={title} image={profile_image_small} buttons={[
      {
        icon: "heart",
        statusVariant: userLiked,
        onClick: () => {
          regulatoryIntelligenceRepository.sendLike(id);
          setUserLiked(!userLiked);
        },
        tooltip: languages.EN.labels[userLiked ? 'unlike' : 'like'],
      },
      {
        icon: "home",
        onClick: () => window.open(url, '_blank'),
        tooltip: languages.EN.labels.goToPage,
      },
      {
        icon: "share",
        onClick: () => {
          setIsDataActive(false);
          fetchOrganizationMembersForShare.fetchData(organizationRepository.getMyOrganizationMembers());
          callPopup({ type: ACTIONS.LOADING })
        },
        tooltip: languages.EN.labels.share,
      },
    ].concat(canEdit ? [
      {
        icon: "edit",
        onClick: () => callPopup({
          type: ACTIONS.FORM,
          payload: {
            header: `${languages.EN.labels.edit} ${languages.EN.labels.regulatoryIntelligenceArticles}`,
            fields: popupFields(data),
            postAction: (formData) => regulatoryIntelligenceRepository.editArticle(id, formData),
          },
        }),
        tooltip: languages.EN.labels.edit,
      },
      {
        icon: "garbage",
        onClick: () => callPopup({
          type: ACTIONS.DELETE,
          payload: {
            type: languages.EN.labels.regulatoryIntelligenceArticle,
            elementName: title,
            action: () => regulatoryIntelligenceRepository.deleteArticle(id),
          },
        }),
        tooltip: languages.EN.labels.delete,
      },
    ] : []).concat([
      {
        icon: "dots",
        onClick: () => history.push(generatePath(Routes.regulatoryIntelligenceDetails.base, { id: id })),
        tooltip: languages.EN.labels.details,
      },
    ])}>
      <TileItemInfo header={languages.EN.labels.learningArea} value={learningArea} />
      <TileItemInfo header={languages.EN.labels.category} value={category} />
      <TileItemInfo header={languages.EN.labels.language} value={languageName} />
      <TileItemInfo header={languages.EN.labels.likes} value={likes} />
      <TileItemInfo header={languages.EN.labels.added} value={dateFormat(created)} />
      <TileItemImgInfo header={languages.EN.labels.visibility} value={visibility} image={visibilityImg} />
    </TileItem>
  );
};
export default RegulatoryIntelligenceItemTile;
